import Link from "next/link";
import Image from "next/future/image";
import { LeftTopRightBottomBackgroundEffect } from "@/components/backgroundEffect";

const Images = [
  "/images/herosection/01.jpg",
  "/images/herosection/02.jpg",
  "/images/herosection/03.jpg",
  "/images/herosection/04.jpg",
  "/images/herosection/05.jpg",
  "/images/herosection/06.jpg",
  "/images/herosection/07.jpg",
];

const Hero = () => {
  return (
    <LeftTopRightBottomBackgroundEffect>
      <section className="overflow-hidden pt-16 pb-80 sm:pb-40 lg:pr-20 lg:pt-40 lg:pb-48">
        <div className="container relative my-10">
          <div className="sm:max-w-lg">
            <h1 className="font text-4xl font-extrabold tracking-tight sm:text-6xl">
              We are changing the way students think.
            </h1>
            <p className="mt-4 text-start text-xl text-slate-500 md:max-w-prose">
              Here is where you could study, think massively, build things, and share knowledge with
              students that have the same engineering and technology interest through a series of
              robotics workshops, competitions and projects.
            </p>
          </div>
          <div>
            <div className="mt-10">
              <div
                aria-hidden="true"
                className="pointer-events-none lg:absolute lg:inset-y-0 lg:mx-auto lg:w-full lg:max-w-7xl"
              >
                <div className="absolute transform sm:left-1/2 sm:top-0 sm:translate-x-8 lg:left-1/2 lg:top-1/2 lg:-translate-y-1/2 lg:translate-x-8">
                  <div className="flex items-center space-x-6">
                    <div className="grid flex-shrink-0 grid-cols-1 gap-y-6">
                      <div className="h-64 w-44 overflow-hidden rounded-lg sm:opacity-0 lg:opacity-100">
                        <Image
                          priority
                          width={10000}
                          height={10000}
                          src={Images[0]}
                          alt=""
                          className="h-full w-full object-cover object-center"
                        />
                      </div>
                      <div className="h-64 w-44 overflow-hidden rounded-lg">
                        <Image
                          priority={true}
                          width={10000}
                          height={10000}
                          src={Images[1]}
                          alt=""
                          className="h-full w-full object-cover object-center"
                        />
                      </div>
                    </div>
                    <div className="grid flex-shrink-0 grid-cols-1 gap-y-6">
                      <div className="h-64 w-44 overflow-hidden rounded-lg">
                        <Image
                          priority
                          width={10000}
                          height={10000}
                          src={Images[2]}
                          alt=""
                          className="h-full w-full object-cover object-center"
                        />
                      </div>
                      <div className="h-64 w-44 overflow-hidden rounded-lg">
                        <Image
                          priority
                          width={10000}
                          height={10000}
                          src={Images[3]}
                          alt=""
                          className="h-full w-full object-cover object-center"
                        />
                      </div>
                      <div className="h-64 w-44 overflow-hidden rounded-lg">
                        <Image
                          priority
                          width={10000}
                          height={10000}
                          src={Images[4]}
                          alt=""
                          className="h-full w-full object-cover object-center"
                        />
                      </div>
                    </div>
                    <div className="grid flex-shrink-0 grid-cols-1 gap-y-6">
                      <div className="h-64 w-44 overflow-hidden rounded-lg">
                        <Image
                          priority
                          width={10000}
                          height={10000}
                          src={Images[5]}
                          alt=""
                          className="h-full w-full object-cover object-center"
                        />
                      </div>
                      <div className="h-64 w-44 overflow-hidden rounded-lg">
                        <Image
                          priority
                          width={10000}
                          height={10000}
                          src={Images[6]}
                          alt=""
                          className="h-full w-full object-cover object-center"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Link href="/events">
                <a className="inline-block cursor-pointer rounded-md border border-transparent bg-slate-900 py-3 px-10 text-center font-medium text-white hover:bg-slate-700">
                  Our Events
                </a>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </LeftTopRightBottomBackgroundEffect>
  );
};

export default Hero;
